module.exports = __webpack_public_path__ + "img/gophersmu.b434a67d.svg";